export const MAX_DIMENSION = 800;
export const JPEG_QUALITY = 0.8;
